import { Link } from "react-router-dom";
import { formatRupiah } from "../../utils/formatter";

import { getBaseUrl } from "../../api/baseApi";

const BASE_URL = getBaseUrl();

const getImageUrl = (photo) => {
    if (!photo) return "";

    try {
        // Coba parse JSON array
        const parsed = JSON.parse(photo);
        if (Array.isArray(parsed) && parsed.length > 0) {
            return BASE_URL + parsed[0]; // gunakan gambar pertama
        }
    } catch (err) {
        // Jika bukan JSON → gunakan langsung
        return BASE_URL + photo;
    }

    return ""; // fallback
};

function PropertyCardShop({ property, key }) {
    let publicUrl = process.env.PUBLIC_URL + "/";

    return (
        <div key={key} className="col-xl-6 col-sm-6 col-12">
            <div className="ltn__product-item ltn__product-item-4 ltn__product-item-5">
                {/* Gambar */}
                <div className="product-img go-top">
                    <Link
                        to={`/product-details/${property?.property_type ?? ""}/${
                            property?.id ?? ""
                        }`}
                    >
                        <img
                            src={getImageUrl(property.photo)}
                            alt={property.name}
                            style={{
                                width: "100%",
                                height: "auto",
                                objectFit: "cover",
                                borderRadius: 6,
                                maxHeight: "300px" // optional biar tidak terlalu tinggi jika gambar besar
                            }}
                            onError={(e) => {
                                e.target.src = publicUrl + "assets/img/product-3/2.jpg";
                            }}
                        />
                    </Link>
                </div>

                {/* Info */}
                <div className="product-info">
                    {/* Badge */}
                    <div className="product-badge">
                        <ul>
                            <li className="sale-badg">
                                {property?.property_type ?? "Unknown Type"}
                            </li>
                        </ul>
                    </div>

                    {/* Title */}
                    <h2 className="product-title go-top">
                        <Link
                            to={`/product-details/${property?.property_type ?? ""}/${
                                property?.id ?? ""
                            }`}
                        >
                            {property?.name ?? "Unnamed Property"}
                        </Link>
                    </h2>

                    {/* Lokasi */}
                    <div className="product-img-location">
                        <ul>
                            <li>
                                <span style={{ cursor: 'default' }}>
                                    <i className="flaticon-pin" /> {property?.province ?? "-"},{" "}
                                    {property?.city ?? "-"}
                                </span>
                            </li>
                        </ul>
                    </div>

                    {/* Detail Kamar */}
                    <ul className="ltn__plot-brief">
                        <li>
                            <span>{property?.facilities?.bed ?? "-"}</span> Kamar tidur
                        </li>
                        <li>
                            <span>{property?.facilities?.bath ?? "-"}</span> Kamar mandi
                        </li>
                        <li>
                            <span>{property?.facilities?.sqm ?? "-"}</span> Sqm
                        </li>
                    </ul>
                </div>

                {/* Harga */}
                <div className="product-info-bottom">
                    <div className="product-price">
                        <span>
                            {formatRupiah(property?.rent_price ?? 0)}
                            <label>/{property?.rent_type ?? "bulan"}</label>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PropertyCardShop;
